import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import CommercialDashboard from './CommercialDashboard';
import RepresentantesModal from './RepresentantesModal';
import RepresentativeResultsModal from './RepresentativeResultsModal';
import RepresentativeFollowup from './RepresentativeFollowup';
export default function CommercialDashboardTabs({ onOpenLead, canManageRepresentatives }) {
 const [tab, setTab] = useState('commercial');
 const [section, setSection] = useState('list');
 return <div className="p-3">
  <Tabs id="commercial-dashboard-tabs" activeKey={tab} onSelect={key => { setTab(key); if (key === 'representatives') setSection('list'); }} mountOnEnter unmountOnExit className="mb-4 flex-wrap">
   <Tab eventKey="commercial" title="Visão comercial"><CommercialDashboard onOpenLead={onOpenLead} /></Tab>
   {canManageRepresentatives && <Tab eventKey="representatives" title="Representantes">
    <Tabs id="representative-dashboard-tabs" activeKey={section} onSelect={setSection} mountOnEnter unmountOnExit className="mb-3 flex-wrap">
     <Tab eventKey="list" title="Listagem"><RepresentantesModal show embedded /></Tab>
     <Tab eventKey="results" title="Resultados"><RepresentativeResultsModal embedded /></Tab>
     <Tab eventKey="followup" title="Acompanhamento de retornos"><div className="bg-white border rounded-3 p-3"><RepresentativeFollowup /></div></Tab>
    </Tabs>
   </Tab>}
  </Tabs>
 </div>;
}
